import ReactMarkdown from 'react-markdown';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import rehypeExternalLinks from 'rehype-external-links';
import { ButtonSize, Typography, PrimaryButton } from '@uni-of-exeter/digital.lib.react.ui.kit';

import './error-page.css';
import { APP_TEXT } from '../../const/app-text';
import { useAuthContext } from '../../auth/auth-provider';
import { PageTracker } from '../../components/page-tracker';

const pageText = APP_TEXT.pages.page403;
const cta = APP_TEXT.ctas.return;

const Page403 = () => {
  const { userId } = useAuthContext();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{pageText.metadata.title}</title>
      </Helmet>

      <div className="pageWrapper">
        <div
          id="main-content"
          className={`pageContent`}
        >
          <PageTracker
            pageName="LibraryPage"
            userId={userId}
          />
          <div className={'errorPage'}>
            <div className={'errorPageContent'}>
              <Typography
                className="text"
                variant="h2"
                fontWeight={700}
              >
                {pageText.title}
              </Typography>

              <ReactMarkdown
                rehypePlugins={[[rehypeExternalLinks, { target: '_blank' }]]}
                className={'markdown'}
              >
                {pageText.description.para1}
              </ReactMarkdown>

              <ReactMarkdown
                rehypePlugins={[[rehypeExternalLinks, { target: '_blank' }]]}
                className={'markdown'}
              >
                {pageText.description.para2}
              </ReactMarkdown>
              <PrimaryButton
                className="continueButton"
                aria-label={APP_TEXT.ctas.continue}
                buttonSize={ButtonSize.Small}
                onClick={() => navigate('/')}
              >
                {cta}
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page403;
